module.exports = __webpack_public_path__ + "static/media/youtube.0b9cd8c3.svg";